<template>
  <view>
    <view class="packet-open" wx:style="{{bgStyle}}">
      <view wx:for="{{couponList}}" wx:key="index" class="coupon">
        <view class="left">
          <coupon-price couponInfo="{{item.coupon}}"/>
        </view>
        <view class="right">
          <view class="info">
            <view class="name">{{item.coupon.name}}</view>
            <view wx:if="{{item.coupon.usage_limit}}" class="usage-limit">{{item.coupon.usage_limit}}</view>
            <view wx:if="{{item.coupon.valid_period}}" class="valid-period">{{item.coupon.valid_period}}</view>
          </view>
          <button wx:if="{{item.link}}" class="btn" bindtap="gotoLink(item)">去使用</button>
        </view>
      </view>
      <image class=footer src="{{footerBg}}" mode="widthFix" />
    </view>
    <view class="footer-btn" wx:style="{{btnFooterStyle}}">
      <view class="btn-mock" bindtap="click"><view class="btn" wx:style="{{btnStyle}}">{{ btnText }}</view></view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { pageStyle } from '../../lib/store'
import { utils } from '@didi/webx-js'

createComponent({
  properties: {
    couponList: Array,
    btnText: String,
    template: String,
    config: {
      type: Object,
      value: () =>({}),
    },
  },
  computed: {
    footerBg() {
      return utils.webpUrl(pageStyle[this.template].couponListFooterImage)
    },
    bgStyle() {
      return { backgroundImage: `url(${utils.webpUrl(pageStyle[this.template].couponListBg)})` }
    },
    btnFooterStyle() {
      return { backgroundImage: pageStyle[this.template].couponListBtnFooterBg }
    },
    btnStyle() {
      const btnStyle = {}
      const curStyle = pageStyle[this.template] || {}
      if (curStyle.couponListBtnBoxShadow) {
        btnStyle.boxShadow = curStyle.couponListBtnBoxShadow
      }
      if (curStyle.btnBgImg) {
        btnStyle.backgroundImage = `url(${curStyle.btnBgImg})`
      }
      return btnStyle
      //  { boxShadow: pageStyle[this.template].couponListBtnBoxShadow }
    },
  },
  methods: {
    click(e) {
      this.triggerEvent('click', e.detail)
    },
    gotoLink(item) {
      this.triggerEvent('couponClick', { item })
    },
  },
})
</script>

<style lang="stylus" scoped>
  .packet-open
    box-sizing border-box
    background-size 100% 100%
    background-repeat no-repeat
    width 694rpx
    margin-left 31rpx
    padding 12rpx 25rpx 8rpx 19rpx
    position relative
    margin-bottom 48rpx
    .coupon
      width 650rpx
      height 202rpx
      background-image: url('https://ut-static.udache.com/webx/ut/0XnfbbB94dgngv9kYEfqe.png')
      background-size cover
      display flex
      padding 12rpx 29rpx 12rpx 20rpx
      box-sizing border-box
      & +.coupon
        margin-top 21rpx
      .right
        width 370rpx
        flex-shrink 0
        box-sizing border-box
        display flex
        align-self center
        .info
          flex: 1;
          margin-left 20rpx
          .name
            font-size: 32rpx;
            font-family: PingFang SC;
            font-weight: 600;
            color: #B14536;
            text-shadow: 1px 1px 0px #FFF;
            margin-bottom 10rpx
            line-height 1
          .usage-limit, .valid-period
            font-size: 20rpx;
            font-family: PingFang SC;
            font-weight: 400;
            color: #848484;
            line-height 1.4
        .btn
          padding 0
          align-self: center;
          width: 117rpx;
          height: 47rpx;
          background: #E33C2B;
          border-radius: 23rpx;
          text-align center
          line-height 47rpx
          font-size: 22rpx;
          font-family: PingFang SC;
          font-weight: 600;
          color: #FFF;
          &::after
            border none
      .left
        flex 1
        position relative
        padding-bottom: 24rpx
  .footer
    width 694rpx
    position absolute
    bottom -40rpx
    left 0
  .footer-btn
    height: 180rpx;
    background-image: linear-gradient(180deg, rgba(238,126,56,0.00) 0%, #EE7D35 49%);;
    overflow: hidden;
    position fixed
    bottom 0
    z-index 8
    width 100%
    .btn-mock
      margin: 14rpx auto 0;
      width 480rpx;
      height: 100rpx;
      padding 12rpx 32rpx;
    .btn
      width: 100%
      height 100%
      border-radius: 5.33vw
      background-image: linear-gradient(180deg, #FFFDE5 0%, #FFE490 100%);
      box-shadow: 0 12px 20px 0 rgba(224,117,11,1);
      border-radius: 69rpx;
      font-size: 40rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #A71818;
      line-height 100rpx
      text-align center
      background-size 100%
      background-repeat no-repeat
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {
    "coupon-price": "../common/coupon-price.mpx"
  }
}
</script>
